import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'funnels',
  storeModule.createStoreModule('funnels')
)
